<div id="loginContainer" class="backgroundSand">
  <div class="loginImg">
    <img
      src="../../../assets/images/login/LogoTritonText1.png"
      alt="Logo de triton"
    />
  </div>
  <div class="formContainer">
    <form class="loginForm" [formGroup]="recoveryForm" (ngSubmit)="onSave()">
      <ng-container *ngIf="operation == 'recovery'">
        <div class="passwordContainer">
          <div class="label passwordLabel inputLabel">
            <label id="password">
              <strong>Nueva contraseña</strong>
            </label>
          </div>
          <div class="inputForm passwordInputForm inputText">
            <input
              type="{{ showPassword ? 'password' : 'text' }}"
              formControlName="password"
              name="password"
              required
            />
            <div (click)="changeView('password')" style="cursor: pointer">
              <span *ngIf="showPassword" class="icon">
                <i class="fas fa-eye"></i>
              </span>
              <span *ngIf="!showPassword" class="icon">
                <i class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="passwordContainer">
          <div class="label passwordLabel inputLabel">
            <label id="confirmPassword">
              <strong>Confirmación de nueva contraseña</strong>
            </label>
          </div>
          <div class="inputForm passwordInputForm inputText">
            <input
              type="{{ showConfirm ? 'password' : 'text' }}"
              formControlName="confirmPassword"
              name="confirmPassword"
              required
            />
            <div (click)="changeView('confirm')" style="cursor: pointer">
              <span *ngIf="showConfirm" class="icon">
                <i class="fas fa-eye"></i>
              </span>
              <span *ngIf="!showConfirm" class="icon">
                <i class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="actionContainer">
          <div class="accederButton">
            <button class="submitButton">
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="operation == 'request recovery'">
        <div class="usuarioContainer">
          <div class="label usuarioLabel inputLabel">
            <label id="userCode"><strong>Código de usuario</strong></label>
          </div>
          <div class="inputForm usuarioInputForm inputText">
            <input
              type="text"
              formControlName="userCode"
              name="userCode"
              required
            />
          </div>
        </div>
        <div class="usuarioContainer">
          <div class="label usuarioLabel inputLabel">
            <label id="email"><strong>Email</strong></label>
          </div>
          <div class="inputForm usuarioInputForm inputText">
            <input type="text" formControlName="email" name="email" required />
          </div>
        </div>
        <div class="actionContainer">
          <div class="accederButton">
            <button class="submitButton">Solicitar</button>
          </div>
        </div>
      </ng-container>
    </form>
  </div>

  <div class="brands backgroundWhite">
    <div class="brandLogo">
      <img
        class="seat"
        src="../../../assets/images/login/seat.png"
        alt="Logo de Seat"
      />
    </div>
    <div class="brandLogo">
      <img
        class="cupra"
        src="../../../assets/images/login/cupra.png"
        alt="Logo de Cupra"
      />
    </div>
    <div class="brandLogo">
      <img
        class="vw"
        src="../../../assets/images/login/ww1.png"
        alt="Logo de VW"
      />
    </div>
    <div class="brandLogo">
      <img
        class="audi"
        src="../../../assets/images/login/audi.png"
        alt="Logo de Audi"
      />
    </div>
    <div class="brandLogo">
      <img
        class="skoda"
        src="../../../assets/images/login/skoda.png"
        alt="Logo de Skoda"
      />
    </div>
    <div class="brandLogo">
      <img
        src="../../../assets/images/login/ww2.png"
        alt="Logo grupo VW"
        class="comerciales"
      />
    </div>
  </div>
</div>
<swal
  #confirmSwal
  html="{{ textConfirm }}"
  icon="success"
  [showCancelButton]="false"
  [swalOptions]="{
    confirmButtonText: 'Aceptar',
    allowEscapeKey: false,
    allowOutsideClick: false
  }"
  [focusCancel]="false"
  (confirm)="goLogin()"
>
</swal>
